import { I18n } from '@calendly/i18n';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { batchCheckboxStatusSelector, clearExcludedIds, clearSelection, excludedIdsSelector, paginationSelector, selectAllStatusSelector, selectedEntitiesCountSelector, setSelectAll, togglePageSelection } from 'features/users_page';
const controlsRowCss = "c1utnvqv";
const ControlsRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlsRowCss, props.className)} />;
});
export const BatchControls = () => {
  const dispatch = useDispatch();
  const selectAllStatus = useSelector(selectAllStatusSelector);
  const excludedIds = useSelector(excludedIdsSelector);
  const batchCheckboxStatus = useSelector(batchCheckboxStatusSelector);
  const selectionCount = useSelector(selectedEntitiesCountSelector);
  const {
    totalCount
  } = useSelector(paginationSelector);
  const anySelectedEntities = selectionCount > 0;
  const count = `${selectAllStatus ? totalCount - excludedIds.length : selectionCount}/${totalCount}`;
  return <ControlsRow>
      <MinimalButton onClick={() => {
      dispatch(togglePageSelection());
      dispatch(setSelectAll(true));
    }} disabled={batchCheckboxStatus === 'all'}>
        {I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.select_all')}
      </MinimalButton>
      <BodyText size="medium" color="muted">
        {I18n.t('publisher.organization.members.selected_members_count', {
        count
      })}
      </BodyText>
      <MinimalButton onClick={() => {
      dispatch(setSelectAll(false));
      dispatch(clearExcludedIds());
      dispatch(clearSelection());
    }} disabled={!anySelectedEntities}>
        {I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.clear_all')}
      </MinimalButton>
    </ControlsRow>;
};

require("./batch_controls.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./batch_controls.js");